import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { prettyLocalDate } from '../lib/time';
import { Alert, AlertTitle } from '@material-ui/lab';
import { STATUS_ACTIVE, STATUS_PENDING } from '../api/billing';
import { formatCurrency } from '../lib/currency';

/*
accreditation:
{
  "status": "Active",  Active Canceled Expired PastDue Pending or None
  "accredited": true,
  "accredited_until": "2021-01-06T05:05:00",
  "accredited_by_admin": null,
  "extra_listings": 0,
  "first_payment_date": "2021-04-05",
  "next_payment_date": "2021-04-05",
  "next_payment_amount": 550,
  "paid_through_date": null,
  "trial_duration": 90,
  "plan_name": "Annual Subscription",
  "plan_description": [
    "Annual",
    "A$550",
    "/year",
    "17% Savings"
  ]
}
*/
const useStyles = makeStyles({
  container: {
    marginBottom: '0.5rem',
    marginTop: '0.5rem',
  }
});

const AccreditationSummary = ({subscription}) => {
  const classes = useStyles();
  const subscriptionSummary = () => {
    let detail = '';
    if (subscription.status === STATUS_ACTIVE || subscription.status === STATUS_PENDING) {
      detail = `Next payment ${formatCurrency(subscription.next_payment_amount)} due on ${prettyLocalDate(subscription.next_payment_date)}`;
    } else if (subscription.accredited && !subscription.accredited_by_admin) {
      detail = 'Accredited until ' + prettyLocalDate(subscription.accredited_until);
    }

    return (
      <div>
        <div>
          {subscription.plan_name}
          <span>&nbsp;({subscription.status})</span>
        </div>
        <div>
          {detail}
        </div>
      </div>
    );
  };

  const adminOverride = () => {
    if (subscription.accredited_by_admin === null) return null;
    return (
      <div>by admin</div>
    );
  };

  if (subscription === undefined) return null;

  // TODO: add subscription start date

  const hasSubscription = subscription.status !== 'None';
  const title = subscription.accredited ? 'Accredited' : 'Not Accredited';
  const alertSeverity = subscription.accredited ? 'success' : 'info';

  return (
    <div className={classes.container}>
      <Alert severity={alertSeverity}>
        <AlertTitle>{title}</AlertTitle>
        <div>{adminOverride()}</div>
        {hasSubscription && subscriptionSummary()}
      </Alert>
    </div>
  );
};

AccreditationSummary.propTypes = {
  subscription: PropTypes.object,
};

export default AccreditationSummary;
